import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
function SvgCheckmark(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 14",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M1.5 6.28l5.82 5.752a1 1 0 001.521-.136L16.5 1h0",
    stroke: "inherit",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }));
}
const MemoSvgCheckmark = React.memo(SvgCheckmark);
export default MemoSvgCheckmark;